import { render, staticRenderFns } from "./ModalButton.vue?vue&type=template&id=7431b920&"
import script from "./ModalButton.vue?vue&type=script&lang=js&"
export * from "./ModalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports